module.exports = __webpack_public_path__ + "static/media/planeIcon.ee4d261d.svg";